import { render, staticRenderFns } from "./SummaryDetail.vue?vue&type=template&id=115df0ce&"
import script from "./SummaryDetail.vue?vue&type=script&lang=js&"
export * from "./SummaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports